const SITE_COPY = {
  "homepage": {
    "header": "Mike Vince",
    "subheader": "Sales training for the invoice finance industry"
  },
  "experience": {
    "header": "30 years of experience",
    "paragraphs": [
      "During 30 years in invoice finance I’ve held roles including Client Management, Credit & Risk, Sales and Sales Leadership and latterly as an MD.",
      "In a pressurised sales environment, the invoice finance industry has tended to replace and recruit salespeople instead of investing in their development. The result? Wasted time and spiralling recruitment costs.",
      "The most effective invoice finance businesses know that a salesperson's job is to sell, and to learn to sell better. My role is to make this happen."
    ]
  },
  "productOne": {
    "header": "What I offer",
    "subheader": "Ongoing skillset progression will develop the skills of your existing team. We will also spot and nurture future sales talent from within your own staff. This reinforces your learning culture and makes you an attractive employer.",
    "columns": [
      {
        "iconName": "clipboard list",
        "headline": "Assessment",
        "paragraph": "I connect with your existing coaching or development initiatives and assess your team members to identify key skills and areas for improvement."
      },
      {
        "iconName": "chart line",
        "headline": "Training",
        "paragraph": "I will create and deliver a progressive programme of individual or team training relevant to your business. Together, we will set measurable outcomes to ensure you're getting value."
      }
    ],
    "buttonCopy": "Get in touch",
    "buttonUrl": "/contact"
  },
  "productTwo": {
    "header": "Advantages of my approach",
    // "subheader": "I create bespoke programmes tailored to your business.",
    "listItems": [
      {
        "headline": "Experience",
        "paragraph": "With my proven track record in sales, credit and management, I can support a wide range of business objectives. "
      },
      {
        "headline": "Tailored to you",
        "paragraph": "I create a bespoke programme that addresses the challenges unique to your business and your team."
      },
      {
        "headline": "Complementary",
        "paragraph": "Any programme I create draws on your existing performance appraisals and initiatives."
      }
    ],
    "buttonCopy": "Contact me",
    "buttonUrl": "/contact"
  },
  "productThree": {
    "header": "Other services",
    "subheader": "I can also provide short programmes. If you are expanding your team or taking on trainees, contact me to discuss what you need.",
    "columns": [
      {
        "iconName": null,
        "headline": "Talent spotting",
        "paragraph": "Sales training for non sales people. A half day workshop helps client facing staff with negotiation and objection handling. It also may reveal those whose future lies in business development."
      },
      {
        "iconName": null,
        "headline": "Seminars & workshops",
        "paragraph": "Sales skills including closing techniques, making the deal area smaller, agenda setting and the understanding the psychology of choice. Usually half a day."
      },
      {
        "iconName": null,
        "headline": "Interview programmes",
        "paragraph": "I will attend interviews and develop robust tests based on your criteria. The results and recommendations will save time and inform your decision to offer a sales role to the best candidates."
      }
    ]
  },
  "contactPage": {
    "subheader": "To arrange an initial consultation, please use one of the following ways to get in touch with me.",
    "contactItems": [
      {
        iconName: 'mail',
        name: 'Email',
        subtitle: 'mike@mrv.ltd',
        link: "mailto:mike@mrv.ltd"
      },
        // {
        //   iconName: 'calendar',
        //   name: 'Meet me',
        //   subtitle: 'Schedule a meeting',
        //   link: null
        // },
      {
        iconName: 'phone',
        name: 'Call me',
        subtitle: '07501 391509',
        link: "tel:07501391509"
      },
      {
        iconName: 'linkedin',
        name: 'LinkedIn',
        subtitle: 'Connect with me',
        link: "https://www.linkedin.com/in/mike-vince-02275411/"
      },
      {
        iconName: 'medium',
        name: 'Medium',
        subtitle: 'Read my articles',
        link: "https://medium.com/@mikevince"
      }
    ]
  },
  "privacyPolicy": {
    "date": "09/09/2018",
    "paragraphs": [
      "This is the privacy policy. Of darkness and dismay. And he was alright, the band was altogether . Yes he was alright, the song went on forever . And he was awful nice . Really quite paradise. And he sang all night long . All night long. Oh how I sighed when they asked if I knew his name. And he was alright, the band was altogether . Yes he was alright, the song went on forever . And he was awful nice . Really quite out of sight. The boy in the bright blue jeans . Jumped up on the stage . And lady stardust sang his songs . Of darkness and disgrace. And he was alright, the band was altogether . Yes he was alright, the song went on forever . And he was awful nice . Really quite out of sight. And he sang all night long . Femme fatales emerged from shadows .",
      "Turn and face the strange. Ch-ch-changes. Don't tell them to grow up and out of it. It's the freakiest show. Take a look at the lawman. Beating up the wrong guy. Oh man, wonder if he'll ever know. He's in the best selling show. Is there life on Mars?. It's on America's tortured brow. That Mickey Mouse has grown up a cow. Now the workers have struck for fame. 'Cause Lennon's on sale again. See the mice in their million hordes. From Ibiza to the Norfolk Broads. Rule Britannia is out of bounds. To my mother, my dog, and clowns. But the film is a saddening bore. To the seat with the clearest view. And she's hooked to the silver screen. But the film is a saddening bore. For she's lived it ten times or more. She could spit in the eyes of fools.",
      "It ain't easy, it ain't easy. It ain't easy to get to heaven when you're going down. Keep your 'lectric eye on me babe. Put your ray gun to my head. Press your space face close to mine, love. Freak out in a moonage daydream oh yeah. Keep your 'lectric eye on me babe. Don't let the sun blast your shadow. Don't let the milk float ride your mind. You're so natural, religiously unkind. Oh no, love, you're not alone. You're watching yourself, but you're too unfair. You got your head all tangled up, but if I could only make you care. Oh no, love, you're not alone. No matter what or who you've been. But made it too far. Became the special man, then we were Ziggy's band. Now Ziggy really sang, screwed up eyes and screwed down hairdo."
    ]
  }
}

export default SITE_COPY;


// WEBPACK FOOTER //
// ./src/SiteCopy.js